export default "__VITE_ASSET__e7a28026__"